/* eslint-disable react/no-danger */
import React from "react";

export const renderInnerHtml = (text: string, tokenItems: any[] = []) => {
  if (tokenItems.length > 0) {
    const tokens = text.split("%s");
    return tokens.map((tokenText, index) => (
      <>
        <span
          key={index}
          dangerouslySetInnerHTML={{ __html: tokenText }}
        />
        {tokenItems[index]}
      </>
    ));
  }

  return <span dangerouslySetInnerHTML={{ __html: text }} />;
};
